import type { CellValueChangedEvent } from 'ag-grid-community'

import type {
  GridAggregationRefreshAfterCellEditConfig,
  GridAggregationRefreshAfterRowDataDiffConfig,
} from '../types'

export const shouldRefreshAggregationAfterCellEdit = <Row>(
  event: CellValueChangedEvent<Row>,
  config: GridAggregationRefreshAfterCellEditConfig<Row> | undefined,
): boolean => {
  const enabled = config?.enabled ?? false
  if (!enabled) return false
  if (
    typeof config?.shouldRefresh === 'function' &&
    !config.shouldRefresh(event)
  ) {
    return false
  }

  const onlyWhenAggColumn = config?.onlyWhenAggColumn !== false
  if (onlyWhenAggColumn && !event.colDef.aggFunc) return false

  return true
}

export const refreshAggregationAfterCellEdit = <Row>(
  event: CellValueChangedEvent<Row>,
  config: GridAggregationRefreshAfterCellEditConfig<Row> | undefined,
): void => {
  if (!shouldRefreshAggregationAfterCellEdit(event, config)) {
    return
  }

  event.api.refreshClientSideRowModel('aggregate')
  if (config?.refreshCells === false) return
  event.api.refreshCells({ force: true })
}

export const shouldRefreshAggregationAfterRowDataDiff = <Row>(
  params: { previousRow: Row; nextRow: Row },
  config: GridAggregationRefreshAfterRowDataDiffConfig<Row> | undefined,
): boolean => {
  const enabled = config?.enabled ?? false
  if (!enabled) return false

  if (
    typeof config?.shouldRefresh === 'function' &&
    !config.shouldRefresh(params)
  ) {
    return false
  }

  return true
}
